export default __webpack_public_path__ + "static/media/Beach vibes3.580de9b2.jpg";